"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2["default"])({
      backgroundColor: colors.pageBackground,
      paddingTop: spacing(4)
    }, breakpoint.up('md'), {
      paddingBottom: spacing(5)
    }),
    content: {
      width: '100%',
      maxWidth: breakpoint.values.xl,
      padding: spacing(0, 4),
      display: 'flex',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      overflow: 'hidden'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors, breakpoint }}", function () {
  return [_useTheme2["default"]];
});

var Footer = function Footer(props) {
  var children = props.children,
      flexProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: classes.root,
    justifyContent: "center"
  }, flexProps), (0, _core.jsx)("footer", {
    css: classes.content
  }, children));
};

__signature__(Footer, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Footer;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
  reactHotLoader.register(Footer, "Footer", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();